<!--  -->
<template>
  <div class="">
    <van-dialog
      v-model="show"
      title="长按进入技术售后群咨询"
      show-cancel-button
      :showConfirmButton="false"
    >
      <div class="flex jcc" style="width: 100%">
        <img
          :src="kefuImg"
          style="width: 70vw; height: 70vw; box-sizing: border-box"
          class="pd-12"
        />
      </div>
    </van-dialog>
    <div v-if="kefuImg" class="wh24 pd-016">
      <img
        src="../assets/image/kefu.png"
        class="wh24"
        @click="show = true"
        alt=""
        v-if="type == 0"
      />
      <svg
        v-else
        @click="show = true"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>首页加载</title>
        <g
          id="视觉稿"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="首页加载" transform="translate(-335.000000, -54.000000)">
            <rect fill="##333333" x="0" y="0" width="375" height="1386"></rect>
            <g
              id="kefu"
              transform="translate(335.000000, 54.000000)"
              fill="#ffffff"
              fill-rule="nonzero"
            >
              <path
                d="M19.9851597,7.28752224 C19.8777339,6.81485378 19.7273427,6.35279739 19.5318195,5.90364294 C19.1170619,4.94525635 18.5218252,4.08580094 17.7654374,3.34864299 C17.0089758,2.6116574 16.1279516,2.03363141 15.1502367,1.62960907 C14.1360567,1.21273405 13.0594106,1 11.9506083,1 C10.8418059,1 9.76737585,1.21273405 8.75307271,1.62960907 C7.77326499,2.03363141 6.89433358,2.6116574 6.13797048,3.34864299 C5.38150888,4.08582556 4.7862475,4.94747233 4.37158845,5.90364294 C4.17165784,6.36348334 4.0191492,6.83627492 3.90953207,7.31768419 C2.22915468,7.83336728 1,9.42998064 1,11.3145729 C1,12.4233506 1.4340858,13.4698347 2.22484583,14.2627861 C2.80715605,14.8450471 3.52491186,15.2361921 4.30284384,15.3973184 C4.7325223,15.4876073 5.13654464,15.1588544 5.13226041,14.7204598 L5.09360388,9.04105158 C5.09360388,7.26383588 5.80483486,5.59207619 7.09411646,4.33502479 C8.39211425,3.0714978 10.1175745,2.37526161 11.9505837,2.37526161 C13.785661,2.37526161 15.5090531,3.0714978 16.8048349,4.3329073 C18.0963324,5.59210082 18.8054952,7.26176764 18.8054952,9.03886023 L18.8054952,14.9611398 C18.8054952,16.7382324 18.094215,18.4100905 16.8048349,19.6671912 C16.1654541,20.2920105 15.4098553,20.7855128 14.5807299,21.1198151 C14.6709942,20.8404047 14.7161017,20.5416906 14.7096999,20.232266 C14.6774451,18.7947107 13.5128247,17.6235655 12.0752448,17.5848843 C10.5494936,17.5461786 9.29677564,18.7753332 9.29677564,20.2924914 C9.29677564,21.7687524 10.4829403,22.9721525 11.9526765,23 L12.0752694,23 C13.1410818,22.984956 14.1747132,22.7744133 15.1502367,22.3703663 C16.1301922,21.9664671 17.0089758,21.3883426 17.7654374,20.6513324 C18.5218252,19.9143222 19.1170373,19.0526262 19.5318195,18.0963078 C19.9228168,17.1959799 20.1377668,16.243995 20.1764233,15.2641873 C20.7716847,15.0621638 21.3175051,14.7226511 21.779463,14.2585019 C22.5703215,13.4676433 23.0043088,12.4211592 23.0043088,11.310264 C23.0043088,9.38920661 21.7214536,7.76462267 19.9851597,7.28752224 L19.9851597,7.28752224 Z M3.19822722,13.2893801 C2.66754933,12.7585298 2.37523699,12.0559166 2.37523699,11.3145729 C2.37523699,10.2830343 2.91677318,9.38265716 3.72265112,8.89708677 C3.72265112,8.944361 3.72043514,8.99156137 3.72043514,9.04107621 L3.72043514,13.7040391 C3.53355419,13.5879957 3.35950129,13.4505064 3.19822722,13.2893555 L3.19822722,13.2893801 Z M12.0472989,21.6269297 L11.9870735,21.6269297 C11.2607738,21.6183121 10.6720372,21.0251682 10.6720372,20.2945597 C10.6720372,19.5596177 11.2693669,18.9623127 12.0043088,18.9623127 C12.7392016,18.9623127 13.3365558,19.5596423 13.3365558,20.2945597 C13.334463,21.0165505 12.7606473,21.6032926 12.0472989,21.6269297 Z M20.8060324,13.2893308 C20.6169601,13.4784278 20.4063435,13.6374366 20.1828497,13.7620239 L20.1828497,9.04100234 C20.1828497,8.97439984 20.1828497,8.90565522 20.1807568,8.83900348 C21.0402614,9.30527023 21.6290226,10.2399951 21.6290226,11.3145482 C21.6290226,12.0558919 21.3368334,12.7585298 20.8060324,13.2893308 L20.8060324,13.2893308 Z"
                id="形状"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import appApi from "@/api/appApi";
export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      show: false,
      kefuImg: "",
    };
  },
  mounted() {
    this.getAppCustomerFile();
  },
  methods: {
    async getAppCustomerFile() {
      const res = await appApi.getAppCustomerFile();
      if (res.data != "undefined" && res.data?.data.length)
        return (this.kefuImg = res.data.data[0].url);
    },
  },
};
</script>
<style lang="less" scoped></style>
